import AssessmentHelper from '../common/_assessment-helper';
export default function () {

    const $submitButton = $('#next-button');
    const $instructionMessage = $('.instruction-message');
    const $noAnswerMessage = $('.no-answer-message');

    $submitButton.on('click', function (event) {
        if(!AssessmentHelper.isCorrectAnswer()) {
            event.preventDefault();

            if (!isInstructionShown()) {
                showInstruction();
            } else if (!isErrorMessageShown()) {
                showErrorMessage();
            }
        }
    });

    $('input').on('change', function () {
        if (!isInstructionShown()) {
            showInstruction();
        } else if (AssessmentHelper.isCorrectAnswer() && isErrorMessageShown()) {
            hideErrorMessage();
        } else if (!AssessmentHelper.isCorrectAnswer() && !isErrorMessageShown()) {
            showErrorMessage();
        }
    });

    /**
     * @returns {boolean}
     */
    function isInstructionShown(): boolean {
        return $instructionMessage.css('display') === 'block';
    }

    function showInstruction(): void {
        $instructionMessage.css('display', 'block');
    }

    function isErrorMessageShown(): boolean {
        return $noAnswerMessage.css('display') === 'block';
    }

    function showErrorMessage(): void {
        $noAnswerMessage.css('display', 'block');
    }

    function hideErrorMessage(): void {
        $noAnswerMessage.css('display', 'none');
    }
}